import { Injectable,  } from '@angular/core';
import { HttpParams,  } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';

import { ClienteFilter } from '../filter';
import { ClienteTypeahead } from './cliente-typeahead';

@Injectable({
    providedIn: 'root'
})
export class TypeaheadClienteHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/cliente`
    }

    /** Pesquisa todos os clientes cadastrados para o typeahead */
    search(filter: ClienteFilter, limit: number): Observable<ClienteTypeahead[]> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Limit
        if (limit) {
            params = params.append('limit', limit.toString());
        }

        return this.customHttp.get<ClienteTypeahead[]>(this.pathApi, {params});
    }

    /** Carrega o cliente informado para o Typeahead */
    load(idCliente: number): Observable<ClienteTypeahead> {
        return this.customHttp.get<ClienteTypeahead>(`${this.pathApi}/${idCliente}`);
    }

    /** Carrega o cliente informado para o Typeahead através da sua pessoa */
    loadByPessoa(idPessoa: number): Observable<ClienteTypeahead> {
        return this.customHttp.get<ClienteTypeahead>(`${this.pathApi}/0/pessoa/${idPessoa}`);
    }
}
